// extracted by mini-css-extract-plugin
export var divider = "_rw-0";
export var systemMessage = "_rw-1";